const activeButtons = [];
const activeElements = [];

export default function(mutationsList) {
    for(const mutation of mutationsList) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            if (mutation.addedNodes[0].querySelectorAll("div.webchat__stackedLayout--fromUser > div").length > 0) {
                //disableActiveButtons();
            }
            else {
                for (let i = 0; i < mutation.addedNodes.length; i++) {
                    const addedNode = mutation.addedNodes[i];
                    
                    if (addedNode.className === "ac-container ac-adaptiveCard") {
                        //processActionButtons(addedNode);
                        //processActionElements(addedNode);
                    }
                }
            }
        }
    }

    function processActionButtons(addedNode) {
        const buttons = addedNode.querySelectorAll("div > .ac-actionSet > button.ac-pushButton");

        for (let i = 0; i < buttons.length; i++) {
            const button = buttons[i];

            button.onclick = (function (clickEvent) {
                return function (originalClickEvent) {
                    if (clickEvent) {
                        clickEvent(originalClickEvent);
                    }

                    disableActiveButtons();

                    button.blur();
                    button.classList.add("clicked-button");
                };
            })(button.onclick);

            activeButtons.push(button);
        }
    }

    function disableActiveButtons() {
        while (activeButtons.length > 0) {
            const button = activeButtons.pop();

            button.disabled = true;
            button.classList.add("disabled-button");
            
            button.onclick = () => {
                return false;
            }
        }
    }

    function processActionElements(addedNode) {
        const elements = addedNode.querySelectorAll("div.ac-container.ac-selectable");

        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];

            element.onclick = (function (clickEvent) {
                return function (originalClickEvent) {
                    if (clickEvent) {
                        clickEvent(originalClickEvent);
                    }

                    disableActiveElements();

                    element.blur();
                    element.classList.add("clicked-element");
                };
            })(element.onclick);

            activeElements.push(element);
        }
    }

    function disableActiveElements() {
        while (activeElements.length > 0) {
            const element = activeElements.pop();

            element.disabled = true;
            element.classList.add("disabled-element");
            
            element.onclick = () => {
                return false;
            }
        }
    }
}